$(function() {
  $('.play-button-slide').click(function() {
    $(this).parent().find('.play-button').click();
    return false;
  });

  var quantity = $('#quantity');
  if (quantity.length) {
    setInterval(function() {
      var actualPrice = $('.actual-price.money').data('price');
      var price;
      if (!actualPrice)
        price = parseInt($('meta[itemprop=price]').attr('content'));
      else
        price = parseInt(actualPrice);
      if (price > 0) {
        var count = parseInt(quantity.val());
        $('.actual-price.money').text('$' + (count * price) + ' USD' + (count > 1 ? ' (for ' + count + ')' : ''));
      }
    }, 50);
  }

  $("a[href='#newsletter']").click(function() {
    var d = $(".popup--root");
    if ((d.length == 0 || d.html().length == 0) && window.newsletterHTML !== undefined) {
      if (d.length == 0)
        $('body').append($("<div class='popup--root'></div>").html(window.newsletterHTML));
      else
        $(".popup--root").html(window.newsletterHTML);
    }
    showPopup();
    return false;
  });

  var owlBtns = $('.owl-page');
  owlBtns.attr('role', 'button');
  var index = 0;
  owlBtns.each(function(i, v) {
    $(v).attr('aria-label', index + 1);
    index++;
  });
});

$(document).on('keydown', function(e) {
  if (e.keyCode != 9 || !document.activeElement)
    return;
  if (e.shiftKey && document.activeElement.classList.contains('off-canvas--close')) {
    document.querySelector('.mobile-nav--menu > nav > ul > li:last-child a').focus();
    return false;
  }
  if (!e.shiftKey && document.activeElement.closest('.mobile-nav--menu') && document.activeElement == document.querySelector('.mobile-nav--menu > nav > ul > li:last-child a')) {
    document.querySelector('.off-canvas--close').focus();
    return false;
  }
  if (document.activeElement.closest('.y-menu--level-2--container') && document.activeElement == document.activeElement.closest('.y-menu--level-2--container').querySelector('li:last-child a')) {
    document.activeElement.closest('.y-menu--level-2--container').querySelector('li:first-child a').focus();
    return false;
  }
  if (!e.shiftKey && document.activeElement.classList.contains('modal--close')) {
    document.querySelector('.search--textbox').focus();
    return false;
  }
  if (e.shiftKey && document.activeElement.classList.contains('search--textbox')) {
    document.querySelector('.modal--close').focus();
    return false;
  }
  if (!e.shiftKey && document.activeElement.id == 'email-submit4') {
    document.querySelector('.popup-modal-close').focus();
    return false;
  }
  if (e.shiftKey && document.activeElement.classList.contains('popup-modal-close')) {
    document.querySelector('#email-submit4').focus();
    return false;
  }
});


jQuery(function($) {
  document.documentElement.addEventListener('keydown', (e) => {
    if (e.keyCode === 27) {
      const menu = document.querySelector('li[data-x-menu--open="true"] > a[aria-haspopup="true"][aria-expanded="true"] + div');
      if (menu) {
        jQuery(menu).slideUp();
      }
    }
  });


  document.querySelectorAll('li[data-x-menu--depth="1"] > a').forEach((el) => {
    el.addEventListener('focusin', (e) => {
      const menu = document.querySelector('li[data-x-menu--open="true"] > a[aria-haspopup="true"][aria-expanded="true"] + div');
      if (menu) {
        jQuery(menu).slideUp();
      }
    });
  });
});